import { Button, TextField } from "@mui/material";
import React, { useState, useRef } from "react";
import {
  useCreateModuleMutation,
} from "../../../../redux-toolkit/features/courses/coursesApiSlice";
import { useAlert } from "../../../../hooks/useAlert";
import { RequiredAsterisk } from "../../../UI/RequiredAsterisk/RequiredAsterisk";

export const AddModuleV2 = ({ setShowModule, course, refetch }) => {
  const [module, setModule] = useState("");
  const [createModule] = useCreateModuleMutation();
  const { displayAlert } = useAlert();
  const ref = useRef(null);
  const [moduleError, setModuleError] = useState("");

  React.useEffect(() => {
    ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  const saveModuleHandler = async () => {
    // Validate module name before API call
    if (!module || !module.trim()) {
      setModuleError("Module name is required");
      return;
    }

    setModuleError(""); // Clear error if validation passes
    const data = { name: module, submodules: [] };
    const finalModule = { data, courseId: course?._id };

    try {
      const result = await createModule(finalModule);

      if (result.error) {
        displayAlert({
          open: true,
          message: result.error?.data?.message || "Error adding module",
          type: "error",
          timeout: "1500",
        });
        return;
      }

      setModule("");
      setModuleError("");
      // await setSelectedModule({index:nextModuleIndex})
      setShowModule(false);
      await refetch();
      displayAlert({
        open: true,
        message: "Added New Module Successfully",
        type: "success",
        timeout: "1500",
      });
    } catch (error) {
      displayAlert({
        open: true,
        message: error?.message || "Error adding module",
        type: "error",
        timeout: "1500",
      });
    }
  };
  return (
    <div className="editcourses__accordiansForm">
      <div>
        <h4 className="ftwt__r">
          Module Name <RequiredAsterisk />
        </h4>
        <TextField
          sx={{
            "& legend": { display: "none" },
            "& fieldset": { top: 0 },
            marginTop: "5px",
          }}
          id="outlined-basic"
          value={module}
          onChange={(e) => {
            setModule(e.target.value);
            if (moduleError) setModuleError(""); // Clear error on input
          }}
          error={!!moduleError}
          helperText={moduleError}
          required
          fullWidth
          variant="outlined"
        />
        <div className="editcourses__moduleAction">
          {/* <Button
                        onClick={deleteModuleHandler}
                        style={{
                            color: "var(--grey400)",
                            borderColor: "var(--grey200)",
                        }}
                        variant="outlined">
                        Delete
                    </Button> */}
          <Button ref={ref} onClick={saveModuleHandler} variant="contained">
            Save
          </Button>
        </div>
      </div>
    </div>
  );
};
